<template>
  <div class="main-agent-list">
    <el-row>
      <el-form
        :inline="true"
        :model="searchForm"
        class="demo-form-inline search-form"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model="searchForm.agentName"
            placeholder="合作单位名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="searchForm.contactName"
            placeholder="联系人姓名"
            clearable
          ></el-input>
        </el-form-item>
        <!--<el-form-item>-->
        <!--<el-select-->
        <!--v-model="searchForm.status"-->
        <!--placeholder="合作机构状态"-->
        <!--:default-first-option="true"-->
        <!--clearable-->
        <!--&gt;-->
        <!--<el-option-->
        <!--v-for="item in statusOptions"-->
        <!--:key="item.value"-->
        <!--:label="item.label"-->
        <!--:value="item.value"-->
        <!--&gt;-->
        <!--</el-option>-->
        <!--</el-select>-->
        <!--</el-form-item>-->
        <el-form-item label="创建时间:">
          <el-date-picker
            v-model="registerDate"
            clearable
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            @click="onSearchAgent"
            icon="el-icon-search"
            :loading="agentPager.loading"
            >查询</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addAgent" icon="el-icon-plus"
            >新增</el-button
          >
        </el-form-item>
      </el-form>
    </el-row>
    <!--<el-row class="button">-->
    <!--<el-button size="small" @click="addAgent">创建合作机构</el-button>-->
    <!--</el-row>-->
    <el-card shadow="never" class="card-fix-height scrollable">
      <el-table
        :data="agentPager.tableData"
        v-loading="agentPager.loading"
        row-key="id"
        stripe
        style="width: 100%"
      >
        <el-table-column
          prop="agentName"
          label="合作单位名称"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contactPhone"
          label="合作单位电话"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contactName"
          label="联系人"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="contactName"
          label="合作内容"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="contactName" label="创建人"> </el-table-column>
        <el-table-column
          prop="createDate"
          label="创建时间"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="300">
          <template slot-scope="scope">
            <el-tooltip
              class="item"
              effect="dark"
              content="查看合作机构"
              placement="top-start"
            >
              <el-button
                icon="el-icon-info"
                circle
                type="primary"
                size="mini"
                @click="showAgentInfo(scope.row)"
              ></el-button>
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="编辑合作机构"
              placement="top-start"
            >
              <el-button
                icon="el-icon-edit-outline"
                circle
                type="primary"
                size="mini"
                @click="editAgentInfo(scope.row)"
              ></el-button>
              >
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="dark"
              content="删除合作机构"
              placement="top-start"
            >
              <el-button
                icon="el-icon-delete"
                circle
                type="primary"
                size="mini"
                @click="onDeleteAgent(scope.row)"
              ></el-button>
              >
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-pagination
      class="footer"
      background
      :layout="tableLayout"
      :total="agentPager.tableTotal"
      :current-page="agentPager.currentPage"
      :page-size.sync="pageSize"
      @current-change="onAgentPageChange"
      align="center"
    >
    </el-pagination>

    <el-dialog
      title="合作机构信息"
      :visible.sync="agentInfoVisible"
      width="35%"
      destroy-on-close
    >
      <edit-agent
        :isEdit="isEditAgent"
        :agentId="agentPager.id"
        @closed="cancelSave"
      ></edit-agent>
    </el-dialog>
    <el-dialog
      title="合作机构信息"
      :visible.sync="addAgentVisible"
      width="35%"
      destroy-on-close
    >
      <add-agent @closed="cancelAdd"></add-agent>
    </el-dialog>
    <el-dialog
      title="合作机构项目信息"
      :visible.sync="agentProjectVisible"
      width="50%"
    >
      <el-table
        :data="agentProjectPager.tableData"
        v-loading="agentProjectPager.loading"
      >
        <el-table-column
          prop="projectName"
          label="项目名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="projectCode"
          label="项目编号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="certificateName"
          label="测评量表名称"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="userCount"
          label="参与人数"
          align="center"
        ></el-table-column>
        <el-table-column label="查看参与项目的用户" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="onGetProjectUser(scope.row.id)"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="agentProjectPager.tableTotal > 0"
        class="footer"
        background
        :layout="tableLayout"
        :total="agentProjectPager.tableTotal"
        :current-page="agentProjectPager.currentPage"
        :page-size.sync="pageSize"
        @current-change="onProjectPageChange"
        align="center"
      >
      </el-pagination>
    </el-dialog>

    <!--参与项目用户信息-->
  </div>
</template>

<script>
import {
  getAgentPager,
  searchAgentPager,
  getProjectList,
  suspendAgent,
  deleteAgent,
  getProjectUserPager,
  getSubAgentList
} from "@/api/agentInfo";
import { getScaleListByProId } from "@/api/userAssess";
import permission from "@/directive/permission"; // 权限判断指令
import { defaultPageConfig } from "@/config/pagination";
import { formatDate } from "@/utils";
import editAgent from "./edit";
import addAgent from "./add";

export default {
  name: "agentInfo",
  components: { editAgent, addAgent },
  directives: { permission },
  data() {
    return {
      searchForm: {
        agentName: null,
        contactName: null,
        status: null,
        startDate: null,
        endDate: null
      },
      statusOptions: [
        { label: "未创建", value: 1 },
        { label: "已创建", value: 2 },
        { label: "已暂停", value: 3 }
      ],
      agentPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      projectUserPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      agentProjectPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      agentChildrenPager: {
        id: null,
        tableData: [],
        currentPage: 1,
        tableTotal: -1,
        tablePages: 0,
        loading: false
      },
      tableLayout: defaultPageConfig.layout,
      pageSize: 10,
      agentInfoVisible: false,
      agentProjectVisible: false,
      projectUserVisible: false,
      agentChildrenVisible: false,
      isEditAgent: false,
      registerDate: [],
      userScaleList: [],
      userAssessVisible: false,
      addAgentVisible: false
    };
  },
  watch: {
    registerDate(val) {
      if (val && val.length > 0) {
        this.searchForm.startDate = val[0] + " 00:00:00";
        this.searchForm.endDate = val[1] + " 23:59:59";
      } else {
        this.searchForm.startDate = null;
        this.searchForm.endDate = null;
      }
    }
  },
  activated() {
    this.getAgentPager();
  },
  methods: {
    // 格式化账户状态
    statusFormatter(row, column, cellValue) {
      let status = {
        "1": "未创建",
        "2": "已创建",
        "3": "已暂停"
      };
      if (cellValue) {
        return status[cellValue];
      }
      return "未创建";
    },
    storageStatusFormatter(row, column, cellValue) {
      let status = {
        "1": "未入库",
        "2": "审核中",
        "3": "已入库",
        "4": "已过期"
      };
      return status[cellValue];
    },
    // 条件查询
    onSearchAgent() {
      this.agentPager.currentPage = 1;
      this.getAgentPager();
    },
    findAssessReport(row) {
      window.open("/report?userScaleId=" + row.userScaleId);
    },
    // 查询合作机构列表
    getAgentPager() {
      let that = this;
      that.agentPager.loading = true;
      getAgentPager(this.searchForm, {
        page: this.agentPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.agentPager.tableTotal = Number(res.data.total);
            that.agentPager.tablePages = Number(res.data.pages);
            that.agentPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = formatDate(
                  item.createDate,
                  "yyyy-MM-dd HH:mm:ss"
                );
              }
              return item;
            });
          } else {
            that.agentPager.tableTotal = 0;
            that.agentPager.tablePages = 0;
            that.agentPager.tableData = [];
          }
        })
        .finally(() => {
          that.agentPager.loading = false;
        });
    },
    findUserAssess(row) {
      let that = this;
      that.userAssessVisible = true;
      getScaleListByProId({
        projectId: row.projectId,
        userId: row.userId
      }).then(res => {
        if (res && res.code === "200") {
          that.userScaleList = res.data.map(item => {
            if (item.submitTime) {
              item.userScaleStatus = "已测评";
              if (item.submitTime.length >= 10) {
                item.submitTime = item.submitTime.substring(0, 10);
              }
            } else {
              item.userScaleStatus = "未测评";
            }
            return item;
          });
        }
      });
    },
    searchAgentPager() {
      let that = this;
      that.agentPager.loading = true;
      searchAgentPager(this.searchForm, {
        page: this.agentPager.currentPage,
        pageSize: this.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.agentPager.tableTotal = Number(res.data.total);
            that.agentPager.tablePages = Number(res.data.pages);
            that.agentPager.tableData = res.data.list.map(item => {
              if (item.createDate) {
                item.createDate = formatDate(
                  item.createDate,
                  "yyyy-MM-dd HH:mm:ss"
                );
              }
              return item;
            });
          } else {
            that.agentPager.tableTotal = 0;
            that.agentPager.tablePages = 0;
            that.agentPager.tableData = [];
          }
        })
        .finally(() => {
          that.agentPager.loading = false;
        });
    },
    cancelSave() {
      this.agentInfoVisible = false;
      this.getAgentPager();
    },
    cancelAdd() {
      this.addAgentVisible = false;
      this.getAgentPager();
    },
    // 时间格式化
    formatTime(timestamp) {
      let date = new Date(timestamp);
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let day = date.getDate();
      let hour = date.getHours();
      let minute = date.getMinutes();
      let second = date.getSeconds();
      return (
        [year, month, day].map(this.formatNumber).join("-") +
        " " +
        [hour, minute, second].map(this.formatNumber).join(":")
      );
    },
    formatNumber(n) {
      n = n.toString();
      return n[1] ? n : "0" + n;
    },
    // 合作机构翻页
    onAgentPageChange(page) {
      this.agentPager.currentPage = page;
      this.getAgentPager();
    },
    // 项目翻页
    onProjectPageChange(page) {
      this.agentProjectPager.currentPage = page;
      this.onGetAgentProject(this.agentProjectPager.id);
    },
    // 用户翻页
    onUserPageChange(page) {
      this.projectUserPager.currentPage = page;
      this.onGetProjectUser(this.projectUserPager.id);
    },
    // 子合作机构分页
    onAgentChildrenChange(page) {
      this.agentChildrenPager.currentPage = page;
      this.onGetSubAgentList(this.agentChildrenPager.id);
    },
    // 查询合作机构信息
    showAgentInfo(row) {
      this.agentPager.id = row.agentId;
      this.agentInfoVisible = true;
      this.isEditAgent = false;
    },
    // 编辑合作机构信息
    editAgentInfo(row) {
      this.agentPager.id = row.agentId;
      this.agentInfoVisible = true;
      this.isEditAgent = true;
    },

    // 查询合作机构项目列表
    onGetAgentProject(id) {
      let that = this;
      that.agentProjectVisible = true;
      that.agentProjectPager.id = id;
      that.agentProjectPager.loading = true;
      getProjectList({
        agentId: id,
        page: that.agentProjectPager.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.agentProjectPager.tableData = res.data.list;
            that.agentProjectPager.tableTotal = Number(res.data.total);
            that.agentProjectPager.tablePages = Number(res.data.pages);
          } else {
            that.agentProjectPager.tableTotal = 0;
            that.agentProjectPager.tablePages = 0;
            that.agentProjectPager.tableData = [];
          }
        })
        .finally(() => {
          that.agentProjectPager.loading = false;
        });
    },

    // 查询合作机构子合作机构列表
    onGetSubAgentList(id) {
      let that = this;
      that.agentChildrenVisible = true;
      that.agentChildrenPager.id = id;
      that.agentChildrenPager.loading = true;
      getSubAgentList({
        agentId: id,
        page: that.agentChildrenPager.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.agentChildrenPager.tableData = res.data.list;
            that.agentChildrenPager.tableTotal = Number(res.data.total);
            that.agentChildrenPager.tablePages = Number(res.data.pages);
          } else {
            that.agentChildrenPager.tableTotal = 0;
            that.agentChildrenPager.tablePages = 0;
            that.agentChildrenPager.tableData = [];
          }
        })
        .finally(() => {
          that.agentChildrenPager.loading = false;
        });
    },
    // 暂停合作机构账号
    onSuspendAgent(row) {
      let that = this;
      suspendAgent({ agentId: row.agentId, status: 3 })
        .then(res => {
          if (res && res.code === "200") {
            that.$message({
              message: "操作成功",
              type: "success"
            });
          }
        })
        .finally(() => {
          that.getAgentPager();
        });
    },
    onRecoverAgent(row) {
      let that = this;
      suspendAgent({ agentId: row.agentId, status: 2 })
        .then(res => {
          if (res && res.code === "200") {
            that.$message({
              message: "操作成功",
              type: "success"
            });
          }
        })
        .finally(() => {
          that.getAgentPager();
        });
    },
    // 删除合作机构账号
    onDeleteAgent(row) {
      let that = this;
      that
        .$confirm("您确定要删除该合作机构吗", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that.loadingInstance = that.$loading(false);
          deleteAgent(row)
            .then(() => {
              that.$message({
                message: "操作成功",
                type: "success"
              });
            })
            .finally(() => {
              that.loadingInstance.close();
              that.getAgentPager();
            });
        });
    },
    // 查询参加项目的用户列表
    onGetProjectUser(id) {
      let that = this;
      that.projectUserVisible = true;
      that.projectUserPager.id = id;
      that.projectUserPager.loading = true;
      getProjectUserPager({
        projectId: id,
        page: that.projectUserPager.currentPage,
        pageSize: that.pageSize
      })
        .then(res => {
          if (res && res.code === "200") {
            that.projectUserPager.tableData = res.data.list;
            that.projectUserPager.tableTotal = Number(res.data.total);
            that.projectUserPager.tablePages = Number(res.data.pages);
          } else {
            that.projectUserPager.tableData = [];
            that.projectUserPager.tableTotal = 0;
            that.projectUserPager.tablePages = 0;
          }
        })
        .finally(() => {
          that.projectUserPager.loading = false;
        });
    },
    // 创建合作机构
    addAgent() {
      this.isEditAgent = true;
      this.addAgentVisible = true;
    },
    // 跳转
    jumpPage(router) {
      this.$router.push(router);
    },
    viewCer(cerInfo) {
      window.open(
        "http://pc.cvaetest.com/certificate?certificateCode=" +
          cerInfo.certificateCode
      );
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.main-agent-list {
  .dashboard {
    &-container {
      margin: 30px;
    }
    &-text {
      font-size: 30px;
      line-height: 46px;
    }
  }
  .card-fix-height {
    position: relative;
    height: calc(100vh - 84px - 15px - 40px - 51px - 52px - 2px - 30px);
  }
  .button {
    padding-bottom: 20px;
  }
  /deep/ .el-table__fixed-right {
    height: 100% !important; //设置高优先，以覆盖内联样式
  }
  /deep/ .el-table__fixed {
    height: 100% !important; //设置高优先，以覆盖内联样式
  }
}
</style>
